import { Injectable } from '@angular/core';
import {HttpParams} from "@angular/common/http";
import {plano} from "../models/plano";
import {HttpClientService} from "./http-client.service";

@Injectable({
  providedIn: 'root'
})
export class PlanoService {

  private planoSelected: plano;

  constructor(private http: HttpClientService) { }

  getByIdProyecto(idProyecto: string) {
    let params = new HttpParams().set("idProyecto",idProyecto);
    return this.http.getWithParams('/plano/getbyidproyecto', params);
  }

  public getByIDProyectoPaginated(idProyecto: string, page) {
    let params = new HttpParams().set("idProyecto",idProyecto).set("page",page);
    return this.http.getWithParams('/plano/getbyidproyectopaginated', params);
  }

  public getCountByIDProyecto(idProyecto: string) {
    let params = new HttpParams().set("idProyecto",idProyecto);
    return this.http.getWithParams('/plano/getcountbyidproyecto', params);
  }

  getAll() {
    return this.http.get('/plano/getall');
  }

  setPlanoSelected(plano: plano) {
    this.planoSelected = plano;
  }

  getPlanoSelected() {
    return this.planoSelected;
  }

  public new(plano: plano) {
    return this.http.post('/plano/new', plano);
  }

  public updateMetrosEscala(plano: plano) {
    let body =
      {
        "idPlano": plano.idPlano,
        "metrosPlano": plano.metrosPlano,
        "escalaLuminarias": plano.escalaLuminarias
      }
    return this.http.post('/plano/updatemetrosescala', body);
  }

  public delete(id: string) {
    return this.http.delete('/plano/delete/' + id);
  }

}
